import { useNavigate } from "react-router-dom";
import { Button, Switch, Tooltip } from "antd";
import { disclaimNvr } from "lib/actions";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { showToast } from "ui/components/common";
import { SideviewContext } from "context/SideviewContext";
import { Alert, Select, Modal } from "antd";
import {
  changeNvrType,
  getNvrById,
  resetGps,
  setLowDataMode,
  useWSService,
} from "./service";
import { copyToClipBoard } from "lib/utils";
import dayjs from "dayjs";
import _ from "lodash";
const routerMqttClientConfigDisplay = {
  username: "Username",
  password: "Password",
  brokerAddr: "Broker Addr",
  brokerPort: "Broker Port",
  clientId: "Client Id",
  gpsTopic: "GPS Topic",
  ethernetTopic: "Ethernet Topic",
  cellularTopic: "Cellular Topic",
  sysInfoTopic: "System Info Topic",
  sysStatusTopic: "System Status Topic",
};
import momentTimezone from "moment-timezone";
import { InfoCircleOutlined } from "@ant-design/icons";
import UpgradeCamera from "pages/dashboard/admin/upgrade/components/upgradeCamera";

export default function Form({
  orgId,
  siteId,
  objData,
}: {
  orgId: string;
  siteId: string;
  objData: any;
}) {
  const [removeNvrConfirmModalOpen, setRemoveNvrConfirmModalOpen] =
    useState(false);
  const [timzeZoneLoading, setTimezoneLoading] = useState(false);
  const { setOpenPanel, viewData, setViewData } = useContext(SideviewContext);
  const [typeLoading, setTypeLoading] = useState(false);
  const navigate = useNavigate();
  const { testSpeed, upgradeEdge, setNvrTimezone } = useWSService();
  const [upgradeLoading, setUpgradeLoading] = useState(false);
  const [showConfigurationModal, setShowConfigurationModal] = useState(false);
  const [lowDataModeLoading, setLowDataModeLoading] = useState(false);
  const timerIdRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (timerIdRef.current) {
        clearInterval(timerIdRef.current);
        timerIdRef.current = null;
      }
    };
  }, []);
  async function handleRemoveNvr(nvrId) {
    try {
      await disclaimNvr(orgId, "", nvrId);
      showToast(0, "The NVR has been removed successfully!");
      setOpenPanel(false);
      setTimeout(() => navigate("/dashboard/customers"), 600);
    } catch (error) {
      console.error(error);
      showToast(1, "There was a problem removing the NVR. Please try again.");
    }
  }

  async function handleRouterBrandChange(value) {
    Modal.confirm({
      title: "About to Change Router Brand",
      content:
        "After switching the router brand, you need to reconfigure the GPS on the router to get the GPS information. Please confirm if you want to continue.",
      icon: null,
      async onOk() {
        setTypeLoading(true);
        const res = await changeNvrType(objData.id, objData.type, value, orgId);
        if (res.status === 200) {
          objData.routerBrand = value;
          objData.routerMqttClientConfig = res.data?.routerMqttClientConfig;
          objData.nmeaUrl = res.data?.nmeaUrl;
          setViewData((state) => {
            return { ...state, objData };
          });
          showToast(0, "The NVR type has been changed successfully");
        } else {
          showToast(
            1,
            "There was a problem changing NVR type. Please try again.",
          );
        }
        setTypeLoading(false);
      },
      okText: "Confrim",
      okButtonProps: {
        className: "primaryButton ",
      },
      cancelButtonProps: {
        className: "primaryButton bordered",
      },
    });
  }
  async function handleTypeChange(value) {
    setTypeLoading(true);
    const res = await changeNvrType(objData.id, value, "", orgId);
    if (res.status === 200) {
      setViewData((state) => {
        state.objData.type = value;
        state.objData.isTrailer = value !== "normal";
        state.objData.routerBrand = value === "normal" ? "" : "teltonika";
        state.objData.routerMqttClientConfig = res.data?.routerMqttClientConfig;
        state.objData.nmeaUrl = res.data?.nmeaUrl;
        return { ...state, objData };
      });
      showToast(0, "The NVR type has been changed successfully");
    } else {
      showToast(1, "There was a problem changing NVR type. Please try again.");
    }
    setTypeLoading(false);
  }
  function onLocationCopyClick() {
    copyToClipBoard(
      `${objData.geolocation?.latitude},${objData.geolocation?.longitude}`,
    );
  }
  function onNMEACopy() {
    copyToClipBoard(objData.nmeaUrl);
  }
  async function onReset() {
    Modal.confirm({
      title: "About to Reset the GPS information",
      content:
        "After Reset, you need to reconfigure the GPS on the router to get the GPS information. Please confirm if you want to continue.",
      icon: null,
      async onOk() {
        const res = await resetGps(objData.id, orgId);
        if (res.status === 200) {
          setViewData((state) => {
            state.objData = {
              ...state.objData,
              geolocation: res.data?.geolocation,
              routerMqttClientConfig: res.data?.routerMqttClientConfig,
              nmeaUrl: res.data?.nmeaUrl,
            };
            return { ...state };
          });
          showToast(0, "The GPS has been reset successfully");
        } else {
          showToast(1, "The GPS has been reset failed");
        }
      },
      okText: "Confrim",
      okButtonProps: {
        className: "primaryButton ",
      },
      cancelButtonProps: {
        className: "primaryButton bordered",
      },
    });
  }
  const [speedTestloading, setSpeedTestLoading] = useState(false);
  useEffect(() => {
    if (objData.testStatus === "testing") setSpeedTestLoading(true);
  }, [objData.testStatus]);

  const configurationDetailJsx = useMemo(() => {
    console.log("objData = ", objData);
    return (
      <div className="mb-8">
        {!objData.geolocation?.serialNum && (
          <div style={{ marginTop: "16px" }}>
            <Alert
              style={{
                borderRadius: "16px",
                border: "none",
                backgroundColor: "#FFF7D6",
              }}
              showIcon
              message={
                objData.routerBrand === "milesight"
                  ? "Please paste corresponding fields into the MQTT Configuration of the Milesight device"
                  : "Please paste this url into the HTTPS URL OF GPS of a GPS device"
              }
              type="warning"
            />
          </div>
        )}
        {objData.routerBrand === "teltonika" && objData.nmeaUrl && (
          <>
            <div
              className="mt-4"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>HTTPS URL OF GPS</span>
              <button
                className="text-[#3E83F6] font-semibold hover:text-blue-400"
                onClick={onNMEACopy}
              >
                Copy
              </button>
            </div>
            <div
              className="mt-2"
              style={{
                width: "100%",
                whiteSpace: "pre-wrap",
                overflowWrap: "anywhere",
              }}
            >
              {objData.nmeaUrl}
            </div>
          </>
        )}
        {objData.routerBrand === "milesight" && (
          <div className="mt-4">
            {Object.keys(routerMqttClientConfigDisplay).map((key) => {
              return (
                <div className="flex gap-2 mt-1" key={key}>
                  <p className="text-zinc-500  w-[140px]">
                    {routerMqttClientConfigDisplay[key]}:
                  </p>
                  <p className="ml-1 break-all flex-grow">
                    {objData.routerMqttClientConfig?.[key] || "-"}
                  </p>
                  {key !== "username" && (
                    <button
                      className="text-[#3E83F6] font-semibold hover:text-blue-400"
                      onClick={() =>
                        copyToClipBoard(
                          objData.routerMqttClientConfig?.[key] || "",
                        )
                      }
                    >
                      Copy
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }, [viewData]);

  async function onSpeedTest() {
    setSpeedTestLoading(true);
    try {
      const res: any = await testSpeed(orgId, objData.deviceId);
      setViewData((state) => {
        state.objData.bandwidthLimit =
          res.deviceSpeedTestReplyRes.bandwidthLimit;
        state.objData.testBandwidth = res.deviceSpeedTestReplyRes.testBandwidth;
        state.objData.lastTestedAt = res.deviceSpeedTestReplyRes.lastTestedAt;
        return { ...state };
      });
    } catch (e) {
      if (e.message.indexOf("4020") !== -1) {
        showToast(1, "A test is already in progress");
      } else if (e.message.indexOf("4023") !== -1) {
        showToast(
          1,
          "Bandwidth is too low, please test again in a better network environment.",
        );
      } else {
        showToast(1, "Speed Test Failed. Error:" + e);
      }
    } finally {
      setSpeedTestLoading(false);
    }
  }
  const upgradable = () => {
    if (
      ["success", "failed", "empty"].includes(objData.upgrade.upgradingState) &&
      objData.status === "online"
    ) {
      const nvr_edge = objData.upgrade?.services?.find(
        (item) => item.service === "nvr_edge",
      );
      if (nvr_edge && nvr_edge.upgradable === "need_upgrade") {
        return true;
      }
    }
    return false;
  };
  const upgrade = async () => {
    setUpgradeLoading(true);
    try {
      await upgradeEdge(orgId, objData.id);
      setUpgradeLoading(false);
      setViewData((state) => {
        const _state = _.cloneDeep(state);
        _state.objData.upgrade.upgradingState = "upgrading";
        const nvr_edge = _state.objData.upgrade?.services?.find(
          (item) => item.service === "nvr_edge",
        );
        nvr_edge.upgradingState = "upgrading";
        return _state;
      });
      timerIdRef.current = setInterval(() => {
        getNvrById(objData.id, orgId).then((data) => {
          const nvr = data.data.data;
          if (!["upgrading", "initial"].includes(nvr.upgrade.upgradingState)) {
            if (nvr.upgrade.upgradingState === "success") {
              showToast(0, "Upgrade result:" + nvr.upgrade.upgradingState);
              navigate("/dashboard/customers");
            } else showToast(1, "Upgrade result:" + nvr.upgrade.upgradingState);
            clearInterval(timerIdRef.current);
            setViewData((state) => {
              const _state = _.cloneDeep(state);
              _state.objData.upgrade = nvr.upgrade;
              const index =
                _state.objData.devicePrerequisite?.prerequisiteList?.findIndex(
                  (e) => e.type === "needUpgrade",
                );
              if (index >= 0) {
                _state.objData.devicePrerequisite?.prerequisiteList.splice(
                  index,
                  1,
                );
              }
              return _state;
            });
          }
        });
      }, 5000);
    } catch (e) {
      setUpgradeLoading(false);
      showToast(1, "Upgrade failed");
    }
  };
  async function onTimezoneChange(value) {
    try {
      setTimezoneLoading(true);
      await setNvrTimezone(objData.id, value, orgId);
      showToast(0, "Timezone updated successfully");
      setViewData((state) => {
        state.objData.timezone = value;
        return { ...state };
      });
    } catch (e) {
      showToast(1, "Failed to update timezone");
    } finally {
      setTimezoneLoading(false);
    }
  }
  const timeZonesOption = useMemo(() => {
    const timeZonesOption = momentTimezone.tz.names().map((timeZone) => {
      const offset = momentTimezone.tz(timeZone).format("Z");
      return {
        value: timeZone,
        label: timeZone + "(" + offset + ")",
      };
    });
    return timeZonesOption;
  }, []);
  const changeLowDataMode = async (value) => {
    setLowDataModeLoading(true);
    const res = await setLowDataMode(value, objData.id, orgId);
    setLowDataModeLoading(false);
    if (res.status !== 200) {
      showToast(1, "Failed to change Low Data Mode");
      return;
    }
    setViewData((state) => {
      state.objData.enableSaveMode = value;
      return { ...state };
    });
  };
  return (
    <>
      {objData?.devicePrerequisite?.prerequisiteList?.length > 0 && (
        <div className="flex flex-col mb-4 gap-2 font-semibold text-red-500">
          {objData?.devicePrerequisite?.prerequisiteList?.map((e, i) => (
            <p key={i} className="rounded-2xl  bg-red-100 px-6 py-4 ">
              {e.msg}
            </p>
          ))}
        </div>
      )}

      <div className="bg-zinc-50 p-3 mt-3 rounded-lg mb-3">
        <table className="table-auto gap-y-3">
          <tbody>
            <tr>
              <td className="pb-3 text-neutral-500">Model</td>
              <td className="pb-3 pl-3 break-all">{objData.model}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500">Vendor</td>
              <td className="pb-3 pl-3 break-all">{objData.manufacturer}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">MAC Address</td>
              <td className="pb-3 pl-3 break-all">{objData.macAddress}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">
                Serial Number
              </td>
              <td className="pb-3 pl-3 break-all">{objData.sn}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">External IP</td>
              <td className="pb-3 pl-3">{objData.externalIp}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">Internal IP</td>
              <td className="pb-3 pl-3">{objData.ips?.at(0)}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">
                Firmware Version
              </td>
              <td className="pb-3 pl-3 break-all">{objData.firmwareVersion}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">
                Edge Version
              </td>
            </tr>
            <tr>
              <td className="pb-3  text-nowrap">Current Version</td>
              <td className="pb-3 pl-3 break-all">
                {objData.upgrade?.services?.find(
                  (item) => item.service === "nvr_edge",
                )?.version || "-"}
              </td>
            </tr>
            <tr>
              <td className="pb-3  text-nowrap">Target Version</td>
              <td className="pb-3 pl-3 break-all">
                {objData.upgrade?.services?.find(
                  (item) => item.service === "nvr_edge",
                )?.targetVersion || "-"}
              </td>
            </tr>
          </tbody>
        </table>
        {["upgrading", "initial"].includes(
          objData.upgrade?.services?.find((item) => item.service === "nvr_edge")
            ?.upgradingState,
        ) && (
          <Alert
            style={{ marginBottom: "12px" }}
            message="Upgrading, please do not turn off or restart the device."
            type="info"
            showIcon
          />
        )}
        {["failed"].includes(
          objData.upgrade?.services?.find((item) => item.service === "nvr_edge")
            ?.upgradingState,
        ) && (
          <Alert
            style={{ marginBottom: "12px" }}
            message="Upgrade failed, please Try Again or contact support.."
            type="error"
            showIcon
          />
        )}
        <div style={{ display: "flex", justifyContent: "end", width: "100%" }}>
          <Button
            disabled={!upgradable()}
            className="primaryButton"
            onClick={upgrade}
            loading={upgradeLoading}
          >
            Upgrade Edge
          </Button>
        </div>
      </div>
      {objData?.cameraNeedUpgrade && (
        <div className="bg-zinc-50 p-6 mt-3 rounded-lg mb-3 h-[182px]">
          <p className="text-[#222222] mb-4 font-semibold">Camera Update</p>
          <p className="text-[#717171] mb-4 ">
            Some cameras need firmware updates for better performance.
          </p>
          <UpgradeCamera
            orgId={+orgId}
            deviceId={objData.deviceId}
            buttonClassName="rounded-full bg-[#3E83F6] hover:bg-blue-400 text-white float-right font-semibold px-6 py-2"
          />
        </div>
      )}

      {objData.isTrailer && (
        <div className="bg-zinc-50 p-3 mt-3 rounded-lg mb-3">
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontWeight: "600" }}>GPS</span>
            <span
              style={{ cursor: "pointer", color: "#3E83F6", fontWeight: "600" }}
              onClick={onLocationCopyClick}
            >
              Copy
            </span>
          </div>
          <table className="table-auto gap-y-3 mt-3">
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">Latitude</td>
              <td className="pb-3 pl-3">
                {objData.geolocation?.latitude
                  ? Number(objData.geolocation?.latitude).toFixed(6)
                  : "-"}
              </td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">Longitude</td>
              <td className="pb-3 pl-3">
                {objData.geolocation?.longitude
                  ? Number(objData.geolocation?.longitude).toFixed(6)
                  : "-"}
              </td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">Device SN</td>
              <td className="pb-3 pl-3">
                {objData.geolocation?.serialNum || "N/A"}
              </td>
            </tr>
          </table>
          {objData.geolocation?.ts && Number(objData.geolocation?.ts) && (
            <div style={{ width: "100%" }}>
              <span style={{ color: "#222222" }}>
                {"Updated on " +
                  dayjs(Number(objData.geolocation?.ts)).format(
                    "YYYY-MM-DD HH:mm:ss",
                  )}
              </span>
            </div>
          )}
          <div
            style={{
              width: "100%",
              border: "1px solid #E1E1E1",
              margin: "12px 0px",
            }}
          ></div>
          <div style={{ width: "100%", color: "#222222" }}>
            Please click the reset button if you want to rebind to a new GPS
            device.
          </div>
          <div style={{ marginTop: "12px" }}>
            <span
              style={{
                cursor: "pointer",
                color: "#3E83F6",
                fontWeight: "600",
              }}
              onClick={onReset}
            >
              Reset
            </span>
          </div>
        </div>
      )}

      <div className="b  p-3 mt-3 rounded-lg mb-3">
        <div className="flex gap-1">
          <div className="flex-grow">
            <div className="mt-3 rounded-lg mb-2"> Type</div>
            <Select
              style={{ width: "100%", height: "54px", borderRadius: "16px" }}
              options={[
                { label: "Normal", value: "normal" },
                { label: "Trailer", value: "trailer" },
                // { label: "Robot", value: "robot" },
                { label: "Guardbox", value: "guardbox" },
              ]}
              onChange={handleTypeChange}
              loading={typeLoading}
              value={objData.type}
              disabled={typeLoading}
            />
          </div>
          {objData.isTrailer && (
            <div className="flex-grow">
              <div className="mt-3 rounded-lg mb-2"> Router Brand</div>
              <Select
                style={{ width: "100%", height: "54px", borderRadius: "16px" }}
                options={[
                  { label: "Teltonika", value: "teltonika" },
                  { label: "Milesight", value: "milesight" },
                ]}
                onChange={handleRouterBrandChange}
                loading={typeLoading}
                value={objData.routerBrand || ""}
              />
            </div>
          )}
        </div>
        {objData.isTrailer && (
          <button
            className="text-[#3E83F6] mt-2 font-semibold hover:text-blue-400"
            onClick={() => setShowConfigurationModal(true)}
          >
            View Configuration Details
          </button>
        )}
      </div>

      <div className="bg-zinc-50 p-3 mt-3 rounded-lg mb-3">
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "130px" }}>
            <div style={{ color: "#222222", textWrap: "nowrap" }}>
              Network Bandwidth
            </div>
            <div style={{ marginTop: "8px" }}>
              {objData.testBandwidth
                ? objData.testBandwidth / 1000 + "Mbps"
                : "Not Tested Yet"}
            </div>
            <div
              style={{
                color: "#222222",
                marginTop: "16px",
                textWrap: "nowrap",
              }}
            >
              Current Speed Limit
            </div>
            <div style={{ marginTop: "8px" }}>
              {objData.bandwidthLimit
                ? objData.bandwidthLimit / 1000 + "Mbps"
                : "N/A"}
            </div>
          </div>
          <Button
            className="primaryButton"
            loading={speedTestloading}
            onClick={onSpeedTest}
          >
            Test
          </Button>
        </div>
        <div style={{ width: "100%", marginTop: "12px" }}>
          <span style={{ color: "#222222" }}>
            {objData.lastTestedAt
              ? "Updated on " +
                dayjs(Number(objData.lastTestedAt)).format(
                  "YYYY-MM-DD HH:mm:ss",
                )
              : ""}
          </span>
        </div>
      </div>
      <div className="bg-zinc-50 p-3 mt-3 rounded-lg mb-3">
        <Select
          disabled={timzeZoneLoading}
          loading={timzeZoneLoading}
          showSearch
          placeholder="Select a time zone"
          className="h-[54px] rounded-2xl w-[90%]"
          value={objData.timezone}
          onChange={onTimezoneChange}
          filterOption={(input, option) =>
            ((option?.label ?? "") as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
        >
          {timeZonesOption?.map((timeZone) => (
            <Select.Option value={timeZone.value} key={timeZone.value}>
              {timeZone.label}
            </Select.Option>
          ))}
        </Select>
        &nbsp;
        <Tooltip
          placement="top"
          title={
            "This timezone setting will override the timezone setting in NVR."
          }
        >
          <InfoCircleOutlined />
        </Tooltip>
      </div>
      <div className="bg-zinc-50 p-3 mt-3 rounded-lg mb-3">
        <span>Low Data Mode</span>
        <Switch
          loading={lowDataModeLoading}
          style={{ marginLeft: "8px" }}
          value={objData.enableSaveMode}
          onChange={changeLowDataMode}
        />
        &nbsp;
        <Tooltip
          placement="top"
          title={
            "Enable Low Data Mode will make streaming to stop when no activity(keyboard or mouse) is detected for 5 minutes. "
          }
        >
          <InfoCircleOutlined style={{ verticalAlign: "middle" }} />
        </Tooltip>
      </div>
      <div className="flex justify-between">
        <button
          className="flex items-center rounded-2xl bg-white px-[24px] py-[14px] text-base font-semibold text-blue-500 border border-blue-500 transition-colors hover:text-blue-400 hover:border-blue-400 "
          onClick={() => {
            setOpenPanel(false);
          }}
        >
          Close
        </button>
        <Button
          className="primaryButton danger"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            // setRemovedNvrId(objData.id);
            setRemoveNvrConfirmModalOpen(true);
          }}
        >
          <span className="text-red-500 hover:text-red-400">Delete</span>
        </Button>
      </div>
      <Modal open={removeNvrConfirmModalOpen} closable={false} footer={null}>
        <h1 className="text-xl font-bold">Do you want to delete the nvr?</h1>
        <div className="text-base mt-4">
          This nvr will be permanently deleted from this site.
        </div>

        <div className="flex justify-end mt-6">
          <button
            className="rounded-2xl bg-white px-6 py-4 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              setRemoveNvrConfirmModalOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            className="ml-4 rounded-2xl px-6 py-4 bg-red-500 text-sm font-medium text-white transition-colors hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500 active:bg-red-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              setRemoveNvrConfirmModalOpen(false);
              handleRemoveNvr(objData.id);
            }}
          >
            Delete
          </button>
        </div>
      </Modal>
      <Modal
        open={showConfigurationModal}
        closable={false}
        //footer={null}
        cancelButtonProps={{ className: "hidden" }}
        okButtonProps={{ className: "primaryButton" }}
        title="Configuration Details"
        okText="Close"
        width={600}
        onOk={() => {
          setShowConfigurationModal(false);
        }}
      >
        {configurationDetailJsx}
      </Modal>
    </>
  );
}
